module.exports = __webpack_public_path__ + "img/line.8b816b27.svg";